import { useGetMealConfiguration } from '@/common/integrations/menhir/employee/meal/meal.hooks';
import { TMealPaymentStrategy } from '@/common/integrations/menhir/employee/meal/meal.types';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';

export function useGetMealPaymentStrategy(): TMealPaymentStrategy {
  const { mealConfiguration } = useGetMealConfiguration();
  const { creditsPocket } = useGetPockets();

  const isSinglePaymentEnabled = !!mealConfiguration?.singleTransaction;
  const isCreditsPaymentEnabled = !!creditsPocket?.balance;

  if (isSinglePaymentEnabled) {
    return 'card';
  }

  if (isCreditsPaymentEnabled) {
    return 'credits';
  }

  return 'none';
}
